import KunLoading3 from './src/index'

KunLoading3.install = function (Vue){
	Vue.component(KunLoading3.name, KunLoading3);
}

export default KunLoading3;
